export default {
  body: "'DM Sans', system-ui, -apple-system, sans-serif",
  display: "'Inter Tight', system-ui, -apple-system, sans-serif",
  mono: "'DM Mono', monospace"
}
